export default __webpack_public_path__ + "static/media/system_builder_insane_panel.ba172f82.png";